<div class="home4-offer-banners-section mb-120 mt-100">
  <div class="container-fluid">
    <div class="row gy-5">
      <div class="col-xl-12">
        <div class="row g-4">
          <div
            class="col-lg-4 wow animate fadeInDown"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div class="single-banner">
              <img src="/assets/images/new2/1.jpg" alt="" />
              <div class="banner-content-wrap">
                <div class="banner-content">
                  <h3 data-translation-key="auction_upcoming_auctions">
                    {{ "auction.upcoming_auctions" | translate }}
                  </h3>
                  <div class="price-area">
                    <span
                      data-translation-key="buyer_homepage_horses_records"
                      >{{ "buyer_homepage.horses_records" | translate }}</span
                    >
                    <h3 data-translation-key="upcoming_horses">
                      {{ statistics?.upcoming_horses }}
                    </h3>
                  </div>
                  <a
                    class="primary-btn btn-hover"
                    routerLink="/buyer/auctions/list/all"
                    [queryParams]="{ filterBy: 'upcoming' }"
                    data-translation-key="buyer_homepage_visit_now"
                  >
                    {{ "buyer_homepage.visit_now" | translate }}
                    <span></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 wow animate fadeInDown"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div class="single-banner two">
              <img src="/assets/images/new2/2.jpg" alt="" />
              <div class="banner-content-wrap">
                <div class="banner-content">
                  <h3 data-translation-key="auction_active_auctions">
                    {{ "auction.active_auctions" | translate }}
                  </h3>
                  <div class="price-area">
                    <span
                      data-translation-key="buyer_homepage_horses_records"
                      >{{ "buyer_homepage.horses_records" | translate }}</span
                    >
                    <h3 data-translation-key="active_horses">
                      {{ statistics?.active_horses }}
                    </h3>
                  </div>
                  <a
                    class="primary-btn btn-hover"
                    routerLink="/buyer/auctions/list/all"
                    [queryParams]="{ filterBy: 'active' }"
                    data-translation-key="buyer_homepage_visit_now"
                  >
                    {{ "buyer_homepage.visit_now" | translate }}
                    <span></span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-lg-4 wow animate fadeInDown"
            data-wow-delay="200ms"
            data-wow-duration="1500ms"
          >
            <div class="single-banner three">
              <img src="/assets/images/new2/3.jpg" alt="" />
              <div class="banner-content-wrap">
                <div class="banner-content">
                  <h3 data-translation-key="auction_previous_auctions">
                    {{ "auction.previous_auctions" | translate }}
                  </h3>
                  <div class="price-area">
                    <span
                      data-translation-key="buyer_homepage_horses_records"
                      >{{ "buyer_homepage.horses_records" | translate }}</span
                    >
                    <h3 data-translation-key="previous_horses">
                      {{ statistics?.previous_horses }}
                    </h3>
                  </div>
                  <a
                    class="primary-btn btn-hover"
                    routerLink="/buyer/auctions/list/all"
                    [queryParams]="{ filterBy: 'previous' }"
                    data-translation-key="buyer_homepage_visit_now"
                  >
                    {{ "buyer_homepage.visit_now" | translate }}
                    <span></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
